import { type Clip } from '@air/api/types';

import { ClipUtils } from './ClipUtils';

export const getAssetIsFailed = (asset?: { status?: Clip['status'] | null }) =>
  asset && ClipUtils.isFailed(asset.status);
